/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_New_HeadingInputs */

const en_templates_new_heading = /** @type {(inputs: Templates_New_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New template`)
};

const he_templates_new_heading = /** @type {(inputs: Templates_New_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תבנית חדשה`)
};

/**
* | output |
* | --- |
* | "New template" |
*
* @param {Templates_New_HeadingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const templates_new_heading = /** @type {((inputs?: Templates_New_HeadingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_New_HeadingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_new_heading(inputs)
	return he_templates_new_heading(inputs)
});